import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import user from './modules/user'
import loader from './modules/loader'
import associates from './modules/associates'
import schools from './modules/schools'
import lov from './modules/lov'
import programs from './modules/programs'
import applications from './modules/applications'
import notifications from './modules/notifications'
import students from './modules/students'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: { },
  getters: { },
  mutations: { },
  actions: { },
  modules: {
    auth,
    user,
    loader,
    associates,
    schools,
    lov,
    programs,
    applications,
    notifications,
    students
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js